export function globalFormatDate(value) {
  if (value === 0)
    return "--";

  const date = new Date(value * 1000);
  const options = {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return date.toLocaleString('en-GB', options);
}

export function globalFormatDateShort(value) {
  if (value === 0)
    return "--";

  const date = new Date(value * 1000);
  const MONTHS = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'];
  let month = date.getMonth();

  const options = {
    day: '2-digit'
  };
  let day = date.toLocaleString('en-GB', options);
  if (day.charAt(0) === '0') {
    day = day.charAt(1);
  }

  return day + ' ' + MONTHS[month] + ', ' + date.getFullYear();
}

export function globalRusDate(value) {
  if (value === 0)
    return "--";

  const date = new Date(value * 1000);
  const MONTHS = ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
  let month = date.getMonth();

  const options = {
    day: '2-digit'
  };
  let day = date.toLocaleString('ru-RU', options);
  if (day.charAt(0) === '0') {
    day = day.charAt(1);
  }

  const options2 = {
    hour: '2-digit',
    minute: '2-digit'
  };
  let hours = date.toLocaleString('ru-RU', options2);

  return day + ' ' + MONTHS[month] + ' ' + date.getFullYear() + ', ' + hours;
}

export function globalRusDateLong(value) {
  if (value === 0)
    return "--";

    const date = new Date(value * 1000);
    const MONTHS = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'];
    let month = date.getMonth();

    const options = {
      day: '2-digit'
    };
    let day = date.toLocaleString('en-GB', options);
    if (day.charAt(0) === '0') {
      day = day.charAt(1);
    }

    const options2 = {
      hour: '2-digit',
      minute: '2-digit'
    };
    let hours = date.toLocaleString('ru-RU', options2);

    return day + ' ' + MONTHS[month] + ' ' + date.getFullYear() + ' - ' + hours;
}

export function globalRusDateLong2(value) {
  if (value === 0)
    return "--";

    const date = new Date(value * 1000);
    const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    let month = date.getMonth();

    const WEEKDAYS = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
    let weekDay = WEEKDAYS[date.getDay()];

    const options = {
      day: '2-digit'
    };
    let day = date.toLocaleString('en-GB', options);
    if (day.charAt(0) === '0') {
      day = day.charAt(1);
    }

    const options2 = {
      hour: '2-digit',
      minute: '2-digit'
    };
    let hours = date.toLocaleString('ru-RU', options2);

    return weekDay + ', ' + day + ' ' + MONTHS[month] + ', ' + date.getFullYear();
}

export function globalDateHours(value) {
  if (value === 0)
    return "--";
  const date = new Date(value * 1000);
  const options2 = {
    hour: '2-digit',
    minute: '2-digit'
  };
  let hours = date.toLocaleString('ru-RU', options2);
  return hours;
}

export function globalDateNumeric(value) {
  if (value === 0)
    return "--";

  const date = new Date(value * 1000);
  const options = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  };
  let formattedDate = date.toLocaleString('en-GB', options);
  formattedDate = formattedDate.replace(/\//g, '.'); // Replace all slashes with dots
  return formattedDate;
}
